/* Runde 53 (24/9 2026): Loox på norsk i temaet.
   Loox leverer to ting inn i #looxReviews:
   1) en serverrendret liste («loox-ssr-reviews-feed», skjult med display:none) med faste engelske tekster
      («Customer Reviews», «Verified», «Store owner replied:», «Overall rating … from N reviews», engelske datoer);
   2) etter window.load bytter Loox-skriptet lista ut med en iframe fra loox.io. Iframen er allerede norsk
      (Loox → Settings → General → Localization → Primary language), og vi kan uansett ikke røre innholdet der.
   Dette skriptet oversetter (1) før Loox rekker å bytte, og viser den norske lista som reserve når iframen
   aldri får høyde (dev-server, forhåndsvisning, blokkert loox.io) eller Loox-skriptet ikke laster.
   Avgrenset til #looxReviews. Gjør ingenting hvis Loox ikke finnes. */
(function () {
  if (window.__tsLooxNorsk) return;
  window.__tsLooxNorsk = true;

  var ROT = document.getElementById('looxReviews');
  if (!ROT) return;

  var TEKST = {
    tittel: 'Ord fra kundene',
    verifisert: 'Verifisert kjøp',
    svar: 'Svar fra verkstedet:',
    bilde: 'Kundebilde: ',
    omraade: 'Anmeldelser'
  };

  function dato(iso, fallback) {
    var d = new Date(iso);
    if (isNaN(d.getTime())) return fallback;
    try {
      return new Intl.DateTimeFormat('nb-NO', { day: 'numeric', month: 'long', year: 'numeric' }).format(d);
    } catch (e) { return fallback; }
  }

  function oversett(feed) {
    if (!feed || feed.getAttribute('data-ts-norsk')) return;
    feed.setAttribute('data-ts-norsk', '1');

    var seksjon = feed.querySelector('section[aria-label]');
    if (seksjon) seksjon.setAttribute('aria-label', TEKST.omraade);

    var h3 = feed.querySelector('h3');
    if (h3) {
      h3.textContent = TEKST.tittel;
      // Sida/seksjonen har som regel «Ord fra kundene» som overskrift allerede; da er h3-en bare støy.
      var finnesAlt = false;
      document.querySelectorAll('h1, h2, .ts-eyebrow, .ts-loox__tittel').forEach(function (el) {
        if (!feed.contains(el) && (el.textContent || '').trim() === TEKST.tittel) finnesAlt = true;
      });
      if (finnesAlt) { h3.hidden = true; h3.style.display = 'none'; }
    }

    var sum = feed.querySelector('.loox-ssr-review-summary');
    if (sum) {
      var m = (sum.textContent || '').match(/(\d+(?:[.,]\d+)?)\s*\/\s*5\s*from\s*(\d+)/i);
      if (m) {
        var n = parseInt(m[2], 10);
        sum.textContent = m[1].replace('.', ',') + ' av 5 fra ' + n + (n === 1 ? ' anmeldelse' : ' anmeldelser');
      }
    }

    feed.querySelectorAll('.loox-review-verified').forEach(function (el) { el.textContent = TEKST.verifisert; });
    feed.querySelectorAll('.loox-review-reply-label').forEach(function (el) { el.textContent = TEKST.svar; });
    feed.querySelectorAll('.loox-review-rating').forEach(function (el) {
      var r = (el.textContent || '').match(/(\d)\s*\/\s*5/);
      if (r) { el.textContent = r[1] + ' av 5'; }
    });
    feed.querySelectorAll('time[datetime]').forEach(function (t) {
      t.textContent = dato(t.getAttribute('datetime'), (t.textContent || '').trim());
    });
    feed.querySelectorAll('img[alt^="Customer photo review of "]').forEach(function (img) {
      img.alt = TEKST.bilde + img.alt.replace(/^Customer photo review of /, '');
    });
  }

  var feed = ROT.querySelector('#loox-reviews-feed');
  if (feed) oversett(feed);

  /* Reserve: Loox bytter lista mot en iframe ved window.load. Får iframen aldri høyde, eller kommer den aldri,
     viser vi den norske lista i stedet. Kopien tas nå, før Loox får byttet. */
  var kopi = feed ? feed.cloneNode(true) : null;
  if (!kopi) return;
  var hidingStyle = kopi.querySelector('.loox-temp-hiding-style');
  if (hidingStyle) hidingStyle.parentNode.removeChild(hidingStyle);
  kopi.id = 'ts-loox-reserve';
  kopi.className = 'ts-loox-reserve';
  kopi.hidden = true;

  var reserveVises = false;
  function visReserve(vis) {
    if (vis === reserveVises) return;
    reserveVises = vis;
    if (vis && !kopi.parentNode) {
      ROT.parentNode.insertBefore(kopi, ROT.nextSibling);
      if (!document.getElementById('ts-loox-reserve-css')) {
        var css = document.createElement('style');
        css.id = 'ts-loox-reserve-css';
        css.textContent =
          '.ts-loox-reserve{max-width:1080px;margin:0 auto}' +
          '.ts-loox-reserve h3{font-size:1rem;margin:0 0 .5rem}' +
          '.ts-loox-reserve .loox-ssr-review-summary{margin:0 0 1.5rem;opacity:.7}' +
          '.ts-loox-reserve .loox-review{padding:1.25rem 0;border-top:1px solid rgb(var(--text-color,21 35 21) / .12)}' +
          '.ts-loox-reserve .loox-review-image{max-width:160px;height:auto;display:block;margin-bottom:.75rem}' +
          '.ts-loox-reserve .loox-review-body{margin:0 0 .5rem;white-space:pre-line}' +
          '.ts-loox-reserve .loox-review-metadata,.ts-loox-reserve .loox-review-product,.ts-loox-reserve .loox-review-reply-date{font-size:.875rem;opacity:.7;margin:0}' +
          '.ts-loox-reserve .loox-review-metadata span,.ts-loox-reserve .loox-review-metadata time{margin-right:.75rem}' +
          '.ts-loox-reserve .loox-reviewer-name{font-weight:500;opacity:1}' +
          '.ts-loox-reserve .loox-review-reply{margin:.75rem 0 0 1rem;padding-left:.75rem;border-left:2px solid rgb(var(--text-color,21 35 21) / .2)}' +
          '.ts-loox-reserve .loox-review-reply-body{margin:0}' +
          '.ts-loox-reserve .loox-review-reply-label{font-weight:500;margin-right:.25rem}';
        document.head.appendChild(css);
      }
    }
    kopi.hidden = !vis;
  }

  function iframeHoyde() {
    var f = ROT.querySelector('iframe');
    return f ? f.getBoundingClientRect().height : 0;
  }
  function ssrSynlig() {
    var f = ROT.querySelector('#loox-reviews-feed');
    return !!f && getComputedStyle(f).display !== 'none';
  }

  var start = Date.now();
  var VENT = 8000;
  var sjekkTimer = setInterval(function () {
    var gaatt = Date.now() - start;
    if (iframeHoyde() > 40 || ssrSynlig()) {
      visReserve(false);
      if (gaatt > 60000) clearInterval(sjekkTimer);
      return;
    }
    if (gaatt >= VENT) visReserve(true);
    if (gaatt > 60000) clearInterval(sjekkTimer);
  }, 500);
})();
